import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RouteList } from '@zg-rentals/route-list';
import Page from '@zg-rentals/multibrand-ui/lib/Page';
import PageNotFound from '@zg-rentals/multibrand-ui/lib/PageNotFound';
import styled from 'styled-components';

const StyledRouteList = styled(RouteList)`
  position: absolute;
  z-index: 1;
  width: 100%;
`;

const NotFoundPage = ({ brand }) => (
  // since this app is using an old version of multibrand-ui, do not remove the `hideFooter`
  // prop as that will load legacy onetrust/optanon logic. Also the footer styles and text
  // are very outdated, example "Copyright 2017"
  <Page noPadding className="NotFoundPage" hideFooter>
    <PageNotFound brand={brand} />
    {__DEV__ && <StyledRouteList />}
  </Page>
);

NotFoundPage.propTypes = {
  brand: PropTypes.string,
};

export default connect((state) => ({
  brand: state.app.brand,
}))(NotFoundPage);
